// This code first checks for the existence of `window._env_`, which is
// populated by the docker-entrypoint.sh script in the container.
// If it doesn't exist (i.e., you're running locally), it falls back to
// `process.env`, which is read from your local .env file.

const getEnvValue = (key) => {
  // Check if running in the container with dynamically injected variables
  if (window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  // Otherwise, fall back to the environment variables set locally
  return process.env[key];
};

const getBaseUrl = () => {
  const env = getEnvValue("REACT_APP_ENV");
  switch (env) {
    case "production":
      return getEnvValue("REACT_APP_HOST_NAME_PROD");
    case "development":
      return getEnvValue("REACT_APP_HOST_NAME_DEV");
    case "local":
      return getEnvValue("REACT_APP_HOST_NAME_LOCAL");
    default:
      return getEnvValue("REACT_APP_HOST_NAME_LOCAL");
  }
};

const getContextPath = () => {
  return getEnvValue("REACT_APP_CONTEXT_PATH");
};

export const API_BASE_URL = getBaseUrl();
export const API_CONTEXT_PATH = getContextPath();

export const LOGGED_IN_USER_EMAIL_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/loggedInUserEmail`;
export const USERS_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/users`;
export const SFC_REGIONS_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/sfcregions`;
export const REGION_BY_SFC_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/getRegionBySfc`;
export const USERS_WITH_REGIONS_SFCS_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/getAllUserWithRegionsAndSfcs`;
export const USER_DETAILS_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/userDetails`;
export const CREATE_USER_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/createUserAndAssignSfcRegions`;
export const UPDATE_USER_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/updateUserAndAssignSfcRegions`;
export const DELETE_USER_API = (email) =>
  `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/deleteUserAndSfcRegions?email=${email}`;
export const UPLOAD_USER_AVATAR_API = (email) =>
  `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/user/${email}/uploadAvatar`;
export const FETCH_USER_AVATAR_API = (email) =>
  `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/user/${email}/getAvatar`;

export const CREATE_SFC_REGION_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/createSfcRegion`;
export const DELETE_SFC_REGION_API = (region, sfc) =>
  `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/deleteSfcRegion?region=${region}&sfc=${sfc}`;

export const GET_ALL_PAGE_ROLE_ACCESS_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/refreshAndGetAllPageRoleAccess`;
export const UPDATE_PAGE_ROLE_ACCESS_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/updatePageRoleAccess`;
export const GET_PAGE_ROLES_BY_USER_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/getPageRolesByUser`;

export const GET_APPROVAL_FLOW_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/getApprovalFlowNew`;
export const SAVE_APPROVAL_DATA_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/saveApprovalData`;
export const SEND_APPROVER_EMAIL_NOTIFY_FOR_SELECTED_REPORT_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/gtdp/sendApproverEmailNotifyForSelectedReport`;

export const TPDM_FILTERS_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/tpdm/bbgData/filters`;
export const BBG_REPORT_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/tpdm/bbgData/report`;
export const CREDIT_RATING_FILTERS_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/tpdm/bbgData/creditRatingFilters`;
export const CREDIT_RATING_REPORT_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/tpdm/bbgData/creditRatingReport`;
export const GRAPHING_TOOL_FILTERS_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/tpdm/bbgData/graphingToolFilters`;
export const GRAPHING_TOOL_REPORT_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/tpdm/bbgData/graphingToolReport`;
export const HEDGE_RATIO_SCENARIO_MNEMONICS_API = (selectedModelDatabase) =>
  `${API_BASE_URL}/${API_CONTEXT_PATH}/alm/getScenarioMnemonicsByModel?modelDatabase=${selectedModelDatabase}`;
export const HEDGE_RATIO_FILTERS_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/alm/getHRFilters`;
export const HEDGE_RATIO_GAPRESULT_REPORT_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/alm/getHRGapResultReport`;
export const ADVANCED_NII_RESULT_REPORT_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/alm/getAdvancedNIIReport`;
export const MARKET_VALUE_REPORT_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/alm/getMarketValueReport`;
export const BALANCE_SHEET_REPORT_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/alm/getBalanceSheetReport`;
export const GET_EXOGENEOUS_INPUT_DATA = `${API_BASE_URL}/${API_CONTEXT_PATH}/alm/getExogeneousInputData`;
export const SENSITIVITY_GAPRESULT_REPORT_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/alm/getSensitivityGapReport`;
export const LIQUIDITY_GAPRESULT_REPORT_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/alm/getLiquidityGapReport`;
export const MULTILEDGER_FX_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/alm/getMultiledgerFXByFilter`;

export const EMPYREAN_CREATE_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/alm/createEmpyreanOPDBData`;
export const EMPYREAN_LIST_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/alm/listAllEmpyreanOPDBData`;
export const EMPYREAN_UPDATE_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/alm/updateEmpyreanOPDBData`;
export const EMPYREAN_DELETE_API = (selectedModelDatabase) =>
  `${API_BASE_URL}/${API_CONTEXT_PATH}/alm/deleteEmpyreanOPDBData?modelDatabase=${selectedModelDatabase}`;
export const EMPYREAN_GET_MODEL_DATABASE_CP_DATES_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/alm/getModelDatabaseCPDates`;

export const METRICS_HISTORY_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/metrics/getMetricsHistory`;
export const REGION_METRICS_HISTORY_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/metrics/getRegionMetricsHistory`;
export const METRICS_HISTORY_AVAILABLE_MONTHS_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/metrics/getMetricsHistoryAvailableMonths`;
export const METRICS_HISTORY_UPSERT_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/metrics/upsertMetricsHistory`;
export const FILE_UPLOAD_AND_SAVE_DATA_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/file/uploadAndSaveData`;
export const FILE_UPLOAD_AND_REPLACE_DATA_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/file/uploadAndReplaceData`;
export const FILE_DOWNLOAD_DATA_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/file/downloadFile`;
export const FILE_LOCK_STATUS = `${API_BASE_URL}/${API_CONTEXT_PATH}/file/lockStatus`;

// TODO: {/uploadAndSaveData} Can be used if needed by password approach
export const MFT_UPLOAD_AND_SAVE_DATA_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/sftp/mft/uploadAndSaveData`;
// export const MFT_UPLOAD_AND_SAVE_DATA_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/sftp/mft/uploadAndSaveDataBySSH`;

export const DOCUMENT_GET_ALL_LABELS_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/document/getAllLabels`;
export const DOCUMENT_UPLOAD_AND_SAVE_DATA_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/document/uploadAndSaveDocument`;
export const DOCUMENT_UPLOAD_AND_REPLACE_DATA_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/document/uploadAndReplaceDocument`;
export const DOCUMENT_DOWNLOAD_DATA_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/document/downloadDocument`;
export const DOCUMENT_DELETE_DATA_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/document/deleteDocument`;

export const SEND_EMAIL_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/email/sendMail`;

// Snowflake
export const GLOBAL_CONTROL_HISTORY_ESSBASE_SUMMARY_RECONT_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/snowflake/fetchGlobalControlHistoryEssbaseSummaryRecon`;
export const TREASURY_KRI_ESSBASE_SUMMARY_API = `${API_BASE_URL}/${API_CONTEXT_PATH}/snowflake/fetchTreasuryKRIEssbaseSummary`;

// Google API
export const GET_GOOGLE_RSS_NEWS_FEED_API = (searchQuery) =>
  `${API_BASE_URL}/${API_CONTEXT_PATH}/google/getGoogleNewsFeedApi?searchQuery=${searchQuery}`;
